import styled from "styled-components";
import { COLOR_DASHBOARD_BACKGROUND, MOBILE_WIDTH, spacing } from "../../config";

export const MainContainer = styled.div`

    width: 100vw;
    max-width: 100%;
    height: 100vh;
    max-height: 100%;
    display: flex;
    position: relative;

`
export const RightContainer = styled.div`

    width: 100%;
    min-height: 100%;
    height:fit-content;
    display: flex;
    flex-direction: column;
    background-color: ${COLOR_DASHBOARD_BACKGROUND};

`

export const ContentContainer = styled.div`

    width: 100%;
    max-width: calc(100vw - 256px);
    max-height: calc(100vh - 70px);
    overflow-y: scroll;
    background-color: ${COLOR_DASHBOARD_BACKGROUND};
    padding: ${spacing(4)} ${spacing(2)};
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    
    @media (max-width: ${MOBILE_WIDTH}){
        max-width: 100%;
    }
`